import { useEffect } from 'react'

import { getConfig } from '@/app/config'

import { useAuth } from './useAuth'
import { useShipUserPreference } from './useShipUserPreference'

export const useUserProfile = () => {
  const { isAuthenticated, isCustomerActive } = useAuth()
  const { data, isLoading, error } = useShipUserPreference(isAuthenticated)

  if (error) {
    throw new Error(`Error fetching user profile`)
  }

  useEffect(() => {
    if (data?.owner?.[0]?.value?.useLegacyUI && isCustomerActive) {
      const shipUrl = getConfig().SHIP_URL
      if (shipUrl) {
        // TODO: Uncomment this when ship v2 beta is enabled for all users
        window.location.href = shipUrl
      }
    }
  }, [data, isCustomerActive])

  return {
    isUserProfileLoading: isLoading && !data && isAuthenticated,
  }
}
